/**
 * The firm-rules feature's names that the always-loaded shell needs (ADR-0047): the synced document
 * type, the owner-entry label and the "Incomplete history" label. Kept apart from firmRules.ts and
 * firmFigures.ts (which re-export them) so that reading a label does not put the rules parser and
 * the figure math in the web app's entry chunk (audit S-12 budget; they load with the firm-rules
 * chunk, apps/web/src/risk/firmGate.ts).
 */

export const FIRM_RULES_DOC = "firm_rules" as const;
/** The label of a raw owner-entered firm rule wherever it is shown. */
export const OWNER_ENTRY_LABEL = "Firm rule · your entry";
/** A HELM-calculated figure's label when a needed day of HELM's history is missing or partial. */
export const INCOMPLETE_HISTORY = "Incomplete history";
